module.exports = __webpack_public_path__ + "img/intro_2.afd735f4.jpg";